<template>
    <div>
        <div class="main-content bg-white" v-if="$currentUser.role != 'admin'">
            <span class="alert-danger">У вас нет доступа к этой странице.</span>
        </div>
        <div class="main-content bg-white" v-if="$currentUser.role == 'admin'">
            <div class="page-header">
                <h3 class="page-title">Лог #{{$route.params.id}}</h3>
                <h4>{{log.parsedSubjectType}} ID: {{log.subject_id}}</h4>
            </div>
            <div class="row" v-if="log.description == 'deleted'">
                <div class="col lg-12">
                    <div class="mb-4">Объект удалён пользователем {{log.userName}} {{log.created_at}}</div>
                </div>
            </div>
            <div class="row" v-if="log.description == 'updated'">
                <div class="col-sm-12">
                    <div class="mb-4">Объект обновлён пользователем {{log.userName}} {{log.created_at}}</div>

                    <div v-if="log.changesParsed.length > 0">
                        <div v-if="!isMobile">
                            <b-table hover responsive bordered
                                     small
                                     :items="log.changesParsed"
                                     :fields="fields">
                            </b-table>
                        </div>
                        <div v-if="isMobile">
                            <b-table hover responsive bordered stacked
                                     small
                                     :items="log.changesParsed"
                                     :fields="fields">
                            </b-table>
                        </div>
                    </div>
                    <div v-if="log.changesParsed.length == 0">Объект сохранён без изменений</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import logsDataService from "../../services/logsDataService";

    export default {
        name: 'logView',
        data() {
            return {
                log: {},
                fields: [
                    {
                        key: 'field',
                        label: 'Поле',
                        sortable: true
                    },
                    {
                        key: 'oldValue',
                        label: 'Старое значение',
                        sortable: false
                    },
                    {
                        key: 'newValue',
                        label: 'Новое значение',
                        sortable: false
                    }
                ],
                isMobile: false,
                window: {
                    width: 0,
                    height: 0
                },
                isXl: false,
            }
        },
        methods: {
            getLog (id) {
                logsDataService.getLog(id)
                    .then(log => {
                        this.log = log
                    })
            }
        },
        beforeMount() {
            if (this.$currentUser.role == 'admin') {
                this.getLog(this.$route.params.id)
            }
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            this.isMobile = this.window.width < 415;
            this.isXl = this.window.width > 1199;
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/js/views/front/LogView.vue